// Libraries
import {
  Pipe,
  PipeTransform,
  LOCALE_ID,
  Inject
} from '@angular/core';
import { DatePipe } from '@angular/common';

/**
 * `Capitalize` return First letter with uppercase
 */
@Pipe({name: 'sheDateFormat'})
export class DateFormatPipe implements PipeTransform {
  /**
   * Creates a new `DateFormatPipe` instance.
   */
  constructor(@Inject(LOCALE_ID) private _locale: string) {
  }

  /**
   * Return value date.
   * @param date Data to transform
   * @return date format
   */
  transform(date: Date): string {
    return new DatePipe(this._locale).transform(date, 'd MMMM y, H:mm:ss');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/date-format.pipe.ts